export default __webpack_public_path__ + "static/media/RoboticArm@3x.234176ee.png";